import React, { useState, useEffect } from "react";
import ExportApi from "../../../api/ExportApi";
import axios from "axios";
import { Container } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import BannerCarousel from "./carousel/BannerCarousel";
import "./banner.css";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../../shared/customLoader";
import SeriesSkeleton from "../../../assets/skeleton/seriesSkeleton";
//import Loader from "../../../images/loader/loaderrrr.gif"

function Banner() {
  const navigate = useNavigate();
  const [bannerImages, setBannerImages] = useState([]);
  const [bannerLoader , setBannerLoader] = useState(true)
  const [allSeries, setAllSeries] = useState([]);
  const [miniLeftBanner, setMiniLeftBanner] = useState([]);
  const [miniRightBanner, setMiniRightBanner] = useState([]);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(true);

  const [groupedSeries, setGroupedSeries] = useState({});
  const [groupedModels, setGroupedModels] = useState({});

   const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 500);
      };
  
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  const SearchFilterChecknewd = () => {
    ExportApi.GetAllcategorySerch()
      .then((resp) => {
        //console.log(resp, "SearchFilterChecknewd>>>>>");
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };

  useEffect(() => {
    SearchFilterChecknewd();
  }, []);

  useEffect(() => {
    // Fetch all series first
    ExportApi.getallproductseries()
      .then(function (response) {
        // console.log(response,"response535");
        setAllSeries(response?.data?.data);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("Error fetching series data");
      });
  }, []);

  useEffect(() => {
    setLoad(true);
    ExportApi.getBannerAllList()
      .then(function (response) {
        const data = response.data.data;

        // Filter data for mini left banner
        let MiniFilterBannerData = data?.filter((item) => {
          return (
            item?.category_type === "Mini Banner left" && item?.active === true
          );
        });
        setMiniLeftBanner(MiniFilterBannerData);
        setLoad(false);
        // setMiniBannerCount(MiniFilterBannerData[0]?.imageCount);

        // Filter data for mini right banner
        let MiniRightFilterBannerData = data?.filter((item) => {
          return (
            item?.category_type == "Mini Banner right" && item?.active === true
          );
        });
        setMiniRightBanner(MiniRightFilterBannerData);
        setLoad(false);
        // setMiniBannerCountRight(MiniRightFilterBannerData[0]?.imageCount);

        // Filter data for main banner
        let filterData = data?.filter((item) => {
          return (
            item?.add === true &&
            item?.active === true &&
            item?.category_type == "Main Banner"
          );
        });

        setBannerImages(filterData);
        setLoad(false);
        setBannerLoader(false)
      })
      .catch(function (error) {
        console.log(error);
         setBannerLoader(false)
      });
  }, []);

  useEffect(() => {
    ExportApi.getallkeys()
      .then(function (resp) {
        // Log the response structure to debug the data
        //console.log(resp?.data?.Data?.groupedSeries, "rpppppgroupedSeries");

        // Assuming the data is already grouped by series in an object structure
        setGroupedSeries(resp?.data?.Data?.groupedSeries || {});
        setGroupedModels(resp?.data?.Data?.groupedModels || {});
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const handleSeriesClick = (seriesName) => {
    // Define relatedSeries outside the condition so that it's accessible later
    let relatedSeries = {};  // Define it here

    // Initialize storedData by fetching it from localStorage or using an empty array if not found
    let storedData = JSON.parse(localStorage.getItem("selectedFilterData")) || [];

    // Define the function before it's used
    const addSeriesToLocalStorage = (seriesName, index) => {
      const newFilterData = {
        type: "series",
        name: seriesName,
        checked: true,
        index: index,
      };

      // Check if this filter data is a duplicate
      const isDuplicate = storedData.some(
        (item) =>
          item.type === newFilterData.type &&
          item.name === newFilterData.name &&
          item.index === newFilterData.index
      );

      // If not a duplicate, add to localStorage
      if (!isDuplicate) {
        storedData.push(newFilterData);
      }
    };

    // Check if the series exists in the fetched list
    if (groupedSeries && groupedSeries[seriesName]) {
      // Populate the relatedSeries object with series data
      relatedSeries[seriesName] = groupedSeries[seriesName].map((series) => ({
        name: series.name,
        index: series.index,
      }));
    }

    // Add the selected series to localStorage
    if (relatedSeries[seriesName]) {
      // Add the main series using newFilterData
      relatedSeries[seriesName].forEach((relatedSeriesItem) => {
        const { name, index } = relatedSeriesItem;
        addSeriesToLocalStorage(name, index);
      });

      // Save updated filter data to localStorage
      localStorage.setItem("selectedFilterData", JSON.stringify(storedData));

      // Navigate to the next page or category
      navigate(`/categories/graphic-cards`);
    } else {
      // If the series is not found in the groupedSeries list, show an error
      toast.error(`No product found for the series: ${seriesName}`);
    }
  };

  setTimeout(() => {
    localStorage.setItem("load", "true");
  }, 200);

  useEffect(() => {
    // Check if the page is being reloaded
    if (
      window.performance.navigation.type ===
      window.performance.navigation.TYPE_RELOAD
    ) {
      // Page is being reloaded, perform your action here
      ExportApi.updateVisitPageCount(bannerImages[0]?.pageCount + 1)
        .then(function (response) { })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, [bannerImages]);

  const handleImageClick = (e, id, i) => {
    setLoading(true);
    e.preventDefault();
    ExportApi.updateBannerCountRate(
      id,
      bannerImages[i]?.pageCount,
      bannerImages[i]?.imageCount + 1
    )
      .then(function (response) {
        window.location.href = bannerImages[i]?.image_link;
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  // const handleImageLoaded = () => {
  //   setLoaded(true);
  // };

  return (
    <div className="banner py-4 py-lg-4">
      <Container>
        <div className="filter-box w-100">
          <BannerCarousel
            bannerLoader={bannerLoader}
            bannerImages={bannerImages}
            onClick={(e, id, i) => handleImageClick(e, id, i)}
          />
        </div>

        {
          miniLeftBanner[0]?.imageName && miniRightBanner[0]?.imageName ? (
            <div style={{marginTop : "20px"}} className="banner-container row gx-md-4">
              <div className="filter-box col-lg-6 col-md-6 text-center">
                {/* <ul className="m-0 mb-0 p-0 d-flex align-items-center justify-content-center">
                  <li
                    className="d-flex"
                    onClick={() => handleSeriesClick("RX 6000 Series")}
                  >
                    RX 6000 Series
                  </li>

                  <li
                    className="d-flex"
                    onClick={() => handleSeriesClick("RX 7000 Series")}
                  >
                    RX 7000 Series
                  </li>
                </ul> */}
                <div
                  className="filter-img"

                >

                  <img
                    src={isMobile && miniLeftBanner[0]?.mobileImage ? miniLeftBanner[0]?.mobileImage : miniLeftBanner[0]?.imageName }
                    alt="AMD Chipset Banner"
                    className="w-100"
                    style={{ height: "auto" }}
                    loading="lazy"
                    onClick={() => {
                      window.location.href = miniLeftBanner[0]?.image_link ?? "/categories/graphic-cards";
                    }}
                  />
                </div>
              </div>
              <div className="filter-box col-lg-6 col-md-6 text-center mt-md-0 mt-4 mt-md-0">
                <div
                  className="filter-img"
                >
                  <img
                    src={isMobile && miniRightBanner[0]?.mobileImage ? miniRightBanner[0]?.mobileImage : miniRightBanner[0]?.imageName}
                    alt="Nvidia Chipset Banner"
                    className="w-100"
                    loading="lazy"
                    onClick={() => {
                      window.location.href = miniRightBanner[0]?.image_link ?? "/categories/graphic-cards";
                    }}
                  />
                </div>
              </div>
            </div>
          )
            : (
              <SeriesSkeleton />
            )
        }

      </Container>
    </div>
  );
}

export default Banner;
